module.exports = __webpack_public_path__ + "img/13.ccde3088.jpg";